export enum BlendEvent {
    CHANGE_SHARE_OWNER = 'change_share_owner',
    DISABLE_SHARE = 'disable_share',
    INVITE_TO_SHARE = 'invite_to_share',
    REMOVE_FROM_SHARE = 'remove_from_share',
    UPDATE_SHARE_PERMISSIONS = 'update_share_permissions',
    SIGN_IN = 'SignIn',
    IDENTIFY = '$identify',
    BUTTON_CLICKED = 'button_clicked',
    DELETE_ACCOUNT = 'Delete Account',
    CONTACT_SUPPORT = 'Contact Support',
    HELP_EVENT = 'Help Event',
    GET_HELP_EVENT = 'Get Help Event',
    CANCEL_HELP = 'Cancel Help',
    ADD_FAVORITE_TAG = 'Add Favorite Tag',
    REMOVE_FAVORITE_TAG = 'Remove Favorite Tag',
    RESTORE = 'restore',
    RESTORE_VERSION = 'restore_version',
    PURGE_ALL = 'purge_all',
    BILLING_PROFILE_REMOVED = 'Billing Profile Removed',
    VIEW_FAVORITE_LIST = 'View Favorite List',
    SYNC_KNOWLEDGEBASE = 'Sync Knowledgebase',
    UPLOAD_FILE = 'Upload File',
    CREATE_FILE = 'Create File',
    DOWNLOAD_FILE = 'Download File',
    DOWNLOAD_AS_ZIP = 'Download As Zip',
    VIEW_FILE = 'View File',
    EDIT_FILE_OFFICE = 'Edit File Office',
    SHARE_LINK = 'Share Link',
    JOINED_SHARE = 'joined_share',
    DISMISS_PENDING_SHARE_INVITATION = 'dismiss_pending_share_invitation',
    SHARED_FOLDER_CREATED = 'shared_folder_created',
    SAVE_LINK_SETTINGS = 'save_link_settings',
    UPGRADE_INQUIRY = 'Upgrade Inquiry',
    ANALYTICS_OPT_IN = 'Opt In',
    ANALYTICS_OPT_OUT = 'Opt Out',
    NEW_UI_OPT_IN = 'New UI Opt In',
    NEW_UI_OPT_OUT = 'New UI Opt Out',
    SIGN_UP = 'SignUp',
    PURCHASE_COMPLETED = 'Purchase Completed',
    SUB_USER_ADDED = 'sub_user_added',
    SUB_USER_ROLE_UPDATED = 'sub_user_role_updated',
    SUB_USER_PASSWORD_RESET = 'sub_user_password_reset',
    SUB_USER_REMOVED = 'sub_user_removed',
    NEW_ROLE_CREATED = 'new_role_created',
    ROLE_DELETED = 'role_deleted',
    UPDATE_ROLE_SETTINGS = 'update_role_settings',
    UPLOAD = 'upload',
    DUPLICATE_ITEM = 'duplicate_item',
    RENAME_ITEM = 'rename_item',
    DELETE_ITEMS = 'delete_items',
    DELETE_ITEM = 'delete_item',
    MOVE_ITEMS = 'move_items',
    COPY_ITEMS = 'copy_items',
    COPY_ITEM = 'copy_item',
    BILLING_PROFILE_ADDED = 'billing_profile_added',
    REWARD_REDEEMED = 'reward_redeemed',
    CHANGE_ACCOUNT_SETTING = 'change_account_setting',
    SAVE_BRANDING_CHANGES = 'save_branding_changes',
    RETRY_UPLOAD_BUTTON_DISPLAYED = 'retry_upload_button_displayed',
    ERROR = 'Error',
}

export enum BlendProperties {
    LINK_TYPE_FOLDER = 'folder',
    LINK_PERMISSION_VIEW = 'view only',
    LINK_PERMISSION_DOWNLOAD = 'view & download',
    LINK_PERMISSION_EDITABLE = 'view, downlaod & edit',
    LINK_COMMENTS_DISABLED = 'disabled',
    LINK_COMMENTS_ENABLED_AUTH = 'enabled for authenticated users',
    LINK_COMMENTS_ENABLED_ALL = 'enabled for all users',
    LINK_PERMISSION_HIDE_FOLDER_CONTENTS = "LINK_PERMISSION_HIDE_FOLDER_CONTENTS",
    LINK_PERMISSION_VIEW_FOLDER_CONTENTS = "LINK_PERMISSION_VIEW_FOLDER_CONTENTS",
    LINK_PERMISSION_DOWNLOAD_FOLDER_CONTENTS = "LINK_PERMISSION_DOWNLOAD_FOLDER_CONTENTS",
    LINK_PERMISSION_EDITABLE_FOLDER_CONTENTS = "LINK_PERMISSION_EDITABLE_FOLDER_CONTENTS"
}

export enum PermissionActions {
    CREATED_AT = 'created_at',
    UPDATED_AT = 'updated_at',
    MANAGE_USERS = 'manageUsers',
    VIEW_USERS = 'viewUsers',
    ADD_EDIT_USERS = 'addEditUsers',
    MANAGE_ROLES = 'manageRoles',
    VIEW_ROLES = 'viewRoles',
    ADD_EDIT_ROLES = 'addEditRoles',
    VIEW_BILLING = 'viewBilling',
    MANAGE_BILLING = 'manageBilling',
    PURGE_FILES = 'purgeFiles',
    FORCE_2FA_ON_FIRST_LOGIN = 'force2faOnFirstLogin',
    SHARE_LINKS = 'sharelinks',
    SHARE_LINK_EXPIRY = 'shareLinkExpiry',
    DEFAULT_SHARE_LINK_EXPIRY_TIME = 'shareLinkExpiry',
    SHARE_LINK_PASSWORD = 'shareLinkPassword',
    DEFAULT_SHARE_LINK_PASSWORD = 'shareLinkPassword',
    SHARE_FOLDERS = 'shareFolders',
}

export enum PlanType {
    bpt = 'business-teams',
    per = 'personal',
    lper = 'personal-legacy',
    ps = 'business-solo',
    psp = 'pro-solo-pro',
    bptu = 'business-teams-advanced',
    bptsp = 'business-teams-plus',
    bptup = 'business-teams-advanced-plus',
    free = 'free',
}

export enum WebpathActionType {
    COPY = 'Copy',
    MOVE = 'Move',
    JOINSHARE   = 'Save and join'
}

export enum FieldTypes {
    TEXTBOX = 'textbox',
    DROPDOWN = 'dropdown',
    RADIOBUTTON = 'radiobutton'
}


export enum FieldIdentities {
    ROLENAME = 'roleName',
    CANPURGEFILES = 'canPurgeFiles',
    CANMANAGEUSERS = 'canManageUsers',
    CANMANAGEROLES = 'canManageRoles',
    CANVIEWUSERS = 'canViewUsers',
    CANADDEDITUSERS = 'canAddEditUsers',
    CANVIEWROLES = 'canViewRoles',
    CANADDEDITROLES = 'canAddEitRoles',
    CANVIEWBILLING = 'canViewBilling',
    CANMANAGEBILLING = 'canManageBilling',
    CANFORCE2FALOGIN = 'canForce2faLogin',
    CANSHARELINKS = 'CanSharelinks',
    CANSHARELINKEXPIRYREQUIRED = 'CanShareLinkExpiryRequired',
    DEFAULTSHARELINKEXPIRYTIME = 'DefaultShareLinkExpiryTime',
    CANSHARELINKPASSWORDREQUIRED = 'CanShareLinkPasswordRequired',
    DEFAULTSHARELINKPASSWORD = 'DefaultShareLinkPassword',
    CANSHAREFOLDERS = 'canShareFolders',
}

export enum ModalCloseStates {
    USER_ROLE_UPDATED = 'userRoleUpdated',
    REMOVED = 'removed',
    PASSWORD_UPDATED = 'passwordUpdated',
}

export enum PermissionObjects {
    METADATA = '_metadata',
    ADMIN = 'admin',
    BILLING = 'billing',
    FILES = 'files',
    SETTINGS = 'settings',
    SHARE = 'share',
    FOLDERS = 'folders',
}

export enum PageTitles {
    'dashboard' = 'Dashboard',
    'files' = 'Files',
    'vault' = 'Vault',
    'shares' = 'Shares',
    'recents' = 'Recents',
    'starred' = 'Starred',
    'trash' = 'Trash',
    'users' = 'Users & roles',
    'settings' = 'Settings',
    'file-history'='Version history'
}

export enum snackBarleadIcon {
    default = 'info',
    warning = 'warning',
    critical = 'info',
    success = 'success',
}

export const Constants = {
    PPT_BLOB_TYPE: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    EXCEL_BLOB_TYPE: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    DOCX_BLOB_TYPE: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=UTF-8',
    TEXT_BLOB_TYPE: 'text/plain',
    DOC_FILE_TYPE: '.docx',
    PPT_FILE_TYPE: '.pptx',
    EXCEL_FILE_TYPE: '.xlsx',
    TEXT_FILE_TYPE: '.txt',
    DOCUMENT_TYPE_LIST: ['Word Document', 'PowerPoint Presentation', 'Excel Worksheet', 'Text File'],
    FILE_TYPE_LIST: ['.docx', '.pptx', '.xlsx', '.txt'],
    DOCUMENT_SVG_IMAGE_LIST: ['mime-doc.svg', 'mime-presentation.svg',
        'mime-spreadsheet.svg', 'mime-txt.svg'],
    DOCUMENT_ICON_IMAGE_LIST: ['file-type-docx', 'file-type-ppt', 'file-type-xlsx', 'file-document'],
    DUMMY_TEMPLATES_PATH: './assets/dummyTemplates/',
    DUMMY_MS_WORD_FILE_NAME: 'template.docx',
    DUMMY_MS_EXCEL_FILE_NAME: 'template.xlsx',
    DUMMY_MS_PPT_FILE_NAME: 'template.pptx',
    DUMMY_TEXT_FILE_NAME: 'template.txt',

    MAX_FILE_NAME_LEN: 248
};
export enum MOVE_ACTION_STEP {
    BLANK = -1,
    SELECT_DESTINATION_FOLDER = 1,
    TRANSFER = 2,
    ONE_CONFLICT = 3,
    MANY_CONFLICT = 4,
    FIX_CONFLICT = 5,
    NEW_FOLDER = 6,
    JOIN_SHARE = 7
}


export enum MOVE_CONFLICT {
    ONE_CONFLICT = 1,
    MANY_CONFLICT = 2,
    FIX_CONFLICT = 3,
}
export enum SHARE_DETAILS_OPEN_STATE {
    CLOSE_STATE = -1,
    MEMBER_LIST = 1,
    OPTIONS = 2,
    CHOOSE_OWNER = 3,
    MEMBER_REMOVE = 4,
    REMOVE_SHARING = 5,
    LEAVE_SHARE = 6,
    MEMBER_PERMISSION = 7,
    MEMBER_INVITE = 8,
    VERIFY_EMAIL = 9,
}

export enum SYNC_URLS {
    DESKTOP_APP = 'https://www.sync.com/help/category/desktop-app/'
}
